import {createAction, props} from '@ngrx/store';

export const segmentMainTypesLoaded = createAction(
  '[FiltersConfig] Load segmentMainTypes Success',
  props<{ data: string[] }>()
);
export const segmentSubTypesLoaded = createAction(
  '[FiltersConfig] Load segmentSubTypes Success',
  props<{ data: string[] }>()
);
export const segmentAudienceTypesLoaded = createAction(
  '[FiltersConfig] Load segmentAudienceTypes Success',
  props<{ data: string[] }>()
);
export const brandsLoaded = createAction(
  '[FiltersConfig] Load brands Success',
  props<{ data: string[] }>()
);
export const categoriesLoaded = createAction(
  '[FiltersConfig] Load categories Success',
  props<{ data: string[] }>()
);
